import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {DD_PRIVACY_ALLOW} from '../../../util/datadog/privacy';

export const PanelDuplicateMenuItem = ({onSelect}: {onSelect: () => void}) => {
  return (
    <DropdownMenu.Item
      data-dd-action-name="Duplicate panel"
      data-dd-privacy={DD_PRIVACY_ALLOW}
      onSelect={onSelect}>
      <Icon name="copy" />
      Duplicate panel
    </DropdownMenu.Item>
  );
};
